import React from 'react'
import { IReSolvedFeedCard } from './home'
const cheyouquan_icon = require('static/cheyouquan_icon.png')

export const ResolveFeedCard = ({ info }: { info: IReSolvedFeedCard }) => {
  return (
    <>
      <div className="card_wrapper">
        <h2 className="line-2">{info.content}</h2>
        <div className="footer">
          <div className="footer-left">
            <img
              className="cheyouquan_icon"
              src={cheyouquan_icon}
              alt="车友圈"
            />
            {info?.auto_label?.name}
          </div>
          <span>{info.comment_count}次回答</span>
        </div>
      </div>
      <style jsx>
        {`
          .card_wrapper {
            margin-bottom: 8px;
            width: 380px;
            height: 112px;
            border-radius: 2px;
            padding: 16px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            background-color: #ffffff;
          }
          .card_wrapper:hover {
            cursor: pointer;
          }
          h2 {
            width: 100%;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            color: #1f2129;
          }
          .footer {
            display: flex;
            justify-content: space-between;
          }
          .footer-left {
            display: flex;
            align-items: center;
            height: 20px;
            padding: 0 6px;
            font-size: 12px;
            border-radius: 2px;
            background-color: #f2f4fa;
          }
          span {
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.43;
            letter-spacing: normal;
            color: #1f2129;
          }
          .cheyouquan_icon {
            margin-right: 2px;
            diplay: block;
            width: 14px;
            height: 14px;
          }
        `}
      </style>
    </>
  )
}
